import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const ACTION_LABELS = {
  create_product: "created product", update_product: "updated product",
  create_role: "created role", update_role: "updated role", delete_role: "deleted role",
  create_staff: "added staff", update_staff: "updated staff", delete_staff: "removed staff",
  create_category: "created collection", update_category: "updated collection", delete_category: "deleted collection",
};

export function AuditTab() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/admin/audit").then((r) => setEvents(r.data)).catch((e) => { toast.error(formatApiError(e)); setEvents([]); });
  }, []);

  if (!events) return <p className="text-vv-muted text-sm py-10 animate-pulse">Loading activity…</p>;

  return (
    <div className="max-w-4xl">
      <p className="vv-overline text-vv-muted mb-6">Latest 200 staff actions — newest first</p>
      {events.length === 0 && <p data-testid="audit-empty" className="text-sm text-vv-muted py-6">No activity recorded yet.</p>}
      <div className="space-y-2">
        {events.map((e) => (
          <div key={e.id} data-testid={`audit-row-${e.id}`} className="border border-vv-black/10 px-4 py-3 flex flex-wrap items-baseline gap-x-3 gap-y-1 text-sm">
            <span className="font-mono text-[11px] text-vv-stone shrink-0">{new Date(e.at).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
            <span className="font-medium">{e.actor}</span>
            <span className="text-vv-muted">{ACTION_LABELS[e.action] || e.action}</span>
            <span className="text-vv-black">{e.record}</span>
            {e.detail && <span className="text-[11px] text-vv-stone font-mono truncate max-w-full">{e.detail}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
